import React, { useState } from 'react';
import { FilterItem, AppliedFilterGroup } from '../interfaces/types';

interface FilterDropdownProps {
    filter: FilterItem;
    updateFilter: (filter: FilterItem, selectedFilter: string) => void;
    currentlySelectedFiltersGroups: AppliedFilterGroup[];
    index: number;
    id: string;
}

export const FilterDropdown: React.FC<FilterDropdownProps> = ({
    filter,
    updateFilter,
    currentlySelectedFiltersGroups,
    index,
    id
}) => {
    const [selectedFilter, setSelectedFilter] = useState('');
    const useDefaultValue = currentlySelectedFiltersGroups.filter(
        filterGroup => filterGroup.categoriesGroupName === filter.label
    ).length === 0;

    if (!filter.choices || filter.choices.length === 0) {
        return null;
    }

    return (
        <div className="filter-option">
            <label htmlFor={`filterLabel-${id}`}>{filter.label}</label>
            <select
                id={`filterLabel-${id}`}
                value={useDefaultValue ? "" : selectedFilter}
                onChange={(e) => {
                    updateFilter(filter, e.target.value);
                    setSelectedFilter(e.target.value);
                }}
            >
                <option value="">{filter.defaultChoice || 'Select'}</option>
                {filter.choices.map((choice, choiceIndex) => (
                    <option key={choiceIndex} value={choice}>{choice}</option>
                ))}
            </select>
        </div>
    );
};
